export default __webpack_public_path__ + "static/media/c++.fff906ad.png";